module.exports = __webpack_public_path__ + "static/media/App.2629afe8.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/App.scss
// module id = 2859
// module chunks = 0